module.exports = __webpack_public_path__ + "img/blast-off.2ccfd807.gif";